// @ts-nocheck
import * as Types from '@instamenu/data-access-stats';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ErrorFragment = { __typename?: 'Error', message: string };

export type CreateDirectUploadMutationVariables = Types.Exact<{
  input: Types.CreateDirectUploadMutationInput;
}>;


export type CreateDirectUploadMutation = { __typename?: 'Mutation', createDirectUpload?: { __typename?: 'CreateDirectUploadMutationPayload', headers?: string | null, signedBlobId?: string | null, url?: string | null, errors?: Array<{ __typename?: 'Error', message: string }> | null } | null };

export const ErrorFragmentDoc = gql`
    fragment error on Error {
  message
}
    `;
export const CreateDirectUploadDocument = gql`
    mutation createDirectUpload($input: CreateDirectUploadMutationInput!) {
  createDirectUpload(input: $input) {
    headers
    signedBlobId
    url
    errors {
      ...error
    }
  }
}
    ${ErrorFragmentDoc}`;

export function useCreateDirectUploadMutation() {
  return Urql.useMutation<CreateDirectUploadMutation, CreateDirectUploadMutationVariables>(CreateDirectUploadDocument);
};